import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormHeader } from '@components/FormHeader/FormHeader';
import { Visa } from '@components/Visa/Visa';
import { Check } from '@components/Check/Check';

import style from './DisbursementFormSuccess.module.scss';

const DisbursementFormSuccess: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={style.containerPage}>
      <main className={style.container}>
        <header>
          <FormHeader />
        </header>
        <section className={style.content}>
          <Check />
          <div className={style.text}>
            <h1 className={style.title}>
              {t('disbursementFormSuccess.title')}
            </h1>

            <b className={style.bold}>
              {t('disbursementFormSuccess.subtitle')}
            </b>
            <p className={style.description}>
              {t('disbursementFormSuccess.description')}
            </p>

            <b className={style.bold}>{t('disbursementFormSuccess.caption')}</b>
          </div>
        </section>
        <footer className={style.footer}>
          <p className={style.containerForSecurity}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
          <Visa />
        </footer>
      </main>
    </div>
  );
};

export default DisbursementFormSuccess;
